// extracted by mini-css-extract-plugin
export default {"folderstructureblog":"beb83bdfa4c0a878a646","requiredentries":"d3cd2ef6eef740a33824"};